export const services = [
  {
    id: 1,
    slug: 'precision-machining',
    title: 'Precision Machining',
    shortDescription: 'CNC turning, milling, and gear cutting with tolerances to ±0.001" for oil & gas components.',
    fullDescription: `Our precision machine shop is equipped with advanced CNC horizontal and vertical lathes, milling centers, and horizontal boring machines. We manufacture complex components including shafts, gears, flanges, and custom parts to exact specifications.

Using the latest CAD/CAM software, our experienced machinists produce components ranging from prototype single pieces to production runs, with full reverse engineering and component customization capabilities.`,
    icon: 'cnc',
    media: [
      {
        id: 1,
        type: 'image',
        src: '/images/services/precision-machining.jpg',
        caption: 'Precision CNC Machining Operations'
      }
    ],
    features: [
      'CNC turning — horizontal and vertical',
      'CNC milling and horizontal boring',
      'Gear cutting and spline machining',
      'Shafts and flanges manufacturing',
      'CAD/CAM programming',
      'Reverse engineering and component customization',
      'Tolerances: ±0.001" to ±0.005"',
      'Max turning diameter: Ø1000mm'
    ],
    materials: [
      'Carbon Steel',
      'Stainless Steel (304, 316, 316L)',
      'Alloy Steel (4140, 4340)',
      'Inconel & Nickel Alloys',
      'Duplex Stainless Steel',
      'Brass & Bronze'
    ],
    capabilities: [
      { label: 'Max Turning Diameter', value: 'Ø1000mm' },
      { label: 'Max Turning Length', value: '4000mm' },
      { label: 'Tolerance', value: '±0.001" – ±0.005"' }
    ],
    relatedServices: ['fabrication', 'grinding-finishing', 'reverse-engineering']
  },
  {
    id: 2,
    slug: 'fabrication',
    title: 'Fabrication',
    shortDescription: 'Steel structures, flow lines, piping systems, modular skids, and industrial enclosures.',
    fullDescription: `Our fabrication facility handles everything from structural steel assemblies to complex piping systems and modular process skids. We work with a wide range of materials and specifications to deliver fabricated components for the oil & gas, petrochemical, and industrial sectors.

From design to delivery, our fabrication team provides 3D prototyping, crating and enclosures, and complete structural assemblies built to international standards.`,
    icon: 'fabrication',
    media: [
      {
        id: 1,
        type: 'image',
        src: '/images/services/fabrication.jpg',
        caption: 'Steel Structure Fabrication'
      }
    ],
    features: [
      'Steel structure fabrication',
      'Flow lines and piping systems',
      'Modular skids and process equipment',
      '3D prototyping',
      'Crating and industrial enclosures',
      'Structural assemblies',
      'Plasma and water jet cutting',
      'MIG, TIG, and arc welding'
    ],
    materials: [
      'Carbon Steel',
      'Stainless Steel',
      'Alloy Steel',
      'Duplex Stainless Steel',
      'Inconel',
      'Aluminum'
    ],
    capabilities: [
      { label: 'Plasma Cutting', value: 'X: 2000mm, Y: 8000mm' },
      { label: 'Press Capacity', value: 'Up to 150 Tons' },
      { label: 'Structural Work', value: 'Heavy industrial' }
    ],
    relatedServices: ['precision-machining', 'laser-cutting', 'repair-maintenance']
  },
  {
    id: 3,
    slug: 'repair-maintenance',
    title: 'Repair & Maintenance',
    shortDescription: 'CNC machine repair, industrial consulting, raw material supply, and workforce provision.',
    fullDescription: `We offer comprehensive machine repair and maintenance services for industrial facilities, minimizing downtime and keeping your operations running efficiently. Our experienced technicians handle CNC machine repairs, consulting services, and complete maintenance programs.

We also provide raw material supply, workforce provision, and dynamic balancing services to support your manufacturing and maintenance requirements.`,
    icon: 'welding',
    media: [
      {
        id: 1,
        type: 'image',
        src: '/images/services/repair-maintenance.jpg',
        caption: 'Machine Repair & Maintenance'
      }
    ],
    features: [
      'CNC machine repairing and overhauling',
      'Industrial consulting services',
      'Raw material supply',
      'Workforce provision and staffing',
      'Dynamic balancing',
      'Spare parts supply and manufacturing',
      'Preventive maintenance programs',
      'Emergency repair response'
    ],
    materials: [],
    capabilities: [
      { label: 'Balancing Capacity', value: '300 Kg to 5000 KG' },
      { label: 'Machine Types', value: 'CNC & conventional' },
      { label: 'Service Area', value: 'Saudi Arabia & region' }
    ],
    relatedServices: ['precision-machining', 'grinding-finishing', 'fabrication']
  },
  {
    id: 4,
    slug: 'grinding-finishing',
    title: 'Grinding & Finishing',
    shortDescription: 'Precision grinding, metal processing, stamping, and alignment & balancing services.',
    fullDescription: `Our grinding and finishing department provides precision surface grinding, cylindrical grinding, and finishing operations to achieve the tightest tolerances and best surface finishes. We handle stamping, metal processing, and alignment & balancing for industrial components.

Spare parts manufacturing and finishing operations are available for both new components and repaired parts, ensuring your assemblies meet full specification.`,
    icon: 'finishing',
    media: [
      {
        id: 1,
        type: 'image',
        src: '/images/services/grinding-finishing.jpg',
        caption: 'Precision Grinding & Finishing'
      }
    ],
    features: [
      'Precision surface grinding',
      'Cylindrical grinding',
      'Stamping and metal processing',
      'Alignment and balancing',
      'Spare parts manufacturing',
      'Surface finishing and treatment',
      'Tolerance: ±0.001" achievable',
      'Large part grinding capability'
    ],
    materials: [
      'Carbon Steel',
      'Stainless Steel',
      'Alloy Steel',
      'Inconel',
      'Hard-faced materials',
      'Hardened steels'
    ],
    capabilities: [
      { label: 'Surface Grinder', value: '1000mm × 3000mm' },
      { label: 'Balancing Machine', value: '300 Kg to 5000 KG' },
      { label: 'Heat Treatment', value: '100 Kg to 1400 Kg' }
    ],
    relatedServices: ['precision-machining', 'repair-maintenance', 'reverse-engineering']
  },
  {
    id: 5,
    slug: 'laser-cutting',
    title: 'Laser & Water Jet Cutting',
    shortDescription: 'Laser cutting, water jet cutting, plasma cutting, and 2D/3D engineering design.',
    fullDescription: `Our cutting services facility offers multiple precision cutting technologies to handle any material and thickness requirement. From laser cutting for precise thin-section work to water jet cutting for heat-sensitive materials and plasma cutting for heavy plate, we have the right process for your application.

Our engineering team supports each project with 2D and 3D engineering design and CAD/CAM programming to ensure optimal cut quality and efficiency.`,
    icon: 'prototype',
    media: [
      {
        id: 1,
        type: 'image',
        src: '/images/services/laser-cutting.jpg',
        caption: 'Laser & Plasma Cutting Operations'
      }
    ],
    features: [
      'Laser cutting — precision profiles',
      'Water jet cutting — no heat affected zone',
      'Plasma cutting — up to Y: 8000mm',
      '2D and 3D engineering design',
      'CAD/CAM programming',
      'Nesting and material optimization',
      'Bevel and contour cutting',
      'Prototype to production quantities'
    ],
    materials: [
      'Carbon Steel',
      'Stainless Steel',
      'Aluminum',
      'Alloy Steel',
      'Inconel',
      'Non-ferrous metals'
    ],
    capabilities: [
      { label: 'Plasma Cutting', value: 'X: 2000mm, Y: 8000mm' },
      { label: 'Cutting Methods', value: 'Laser, Water Jet, Plasma' },
      { label: 'Engineering Design', value: '2D & 3D CAD/CAM' }
    ],
    relatedServices: ['fabrication', 'precision-machining', 'reverse-engineering']
  },
  {
    id: 6,
    slug: 'reverse-engineering',
    title: 'Reverse Engineering',
    shortDescription: 'Industrial reverse engineering, CAD/CAM design, die casting, and component recreation.',
    fullDescription: `When original drawings or documentation are unavailable, our reverse engineering team recreates exact specifications from physical components. Using precision measurement and our CAD/CAM capabilities, we recreate 2D drawings and 3D models for obsolete or undocumented parts.

We also provide die casting, component rating, and complete engineering design services in both 2D and 3D formats, supporting our clients in maintaining aging equipment and developing new solutions.`,
    icon: 'assembly',
    media: [
      {
        id: 1,
        type: 'image',
        src: '/images/services/reverse-engineering.jpg',
        caption: 'Reverse Engineering & Component Recreation'
      }
    ],
    features: [
      'Industrial reverse engineering',
      'Die casting and component rating',
      '2D and 3D CAD/CAM design',
      'Engineering design services',
      'Legacy part documentation',
      'Obsolete part replacement',
      'Material analysis and identification',
      'Manufacturing process development'
    ],
    materials: [
      'All metals and alloys',
      'Carbon Steel',
      'Stainless Steel',
      'Alloy Steel',
      'Inconel',
      'Specialty materials'
    ],
    capabilities: [
      { label: 'CAD Software', value: '2D & 3D design' },
      { label: 'Measurement', value: 'Precision dimensional' },
      { label: 'Output', value: 'Drawings & manufactured parts' }
    ],
    relatedServices: ['precision-machining', 'grinding-finishing', 'fabrication']
  }
]

export const getServiceBySlug = (slug) => {
  return services.find(service => service.slug === slug)
}

export const getRelatedServices = (slugs) => {
  return services.filter(service => slugs.includes(service.slug))
}
